import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton, Stack, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { CssTextField } from "../styles/styles";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker, DesktopTimePicker } from "@mui/x-date-pickers";
import "dayjs/locale/es";

function PromocionAddComponents({
    titulo, setTitulo, ratioOtrosBancos, setRatioOtrosBancos, ratioItau, setRatioItau, ratioItauPersonalBank, setRatioItauPersonalBank,
    activoStatus, setActivoStatus, handleCancelar, handleGuardar, montoMinimo, setMontoMinimo, montoMaximo, setMontoMaximo,
    porcentajeAbsorve, setPorcentajeAbsorve, mostrarAlLocatario, setMostrarAlLocatario,
    fechaInicio, handleFechaInicio, fechaHasta, handleFechaHasta, fechaInicioCanjear, 
    handleFechaInicioCanjear, fechaHastaCanjear, handleFechaHastaCanjear
}) {


    let history = useNavigate();








    return (
        <Box>
            <Box sx={{}}>
                <Box sx={{
                    display: 'flex',
                }}>
                    <div style={{}}>



                    </div>

                    <div style={{
                        width: '100%',
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}>
                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={titulo}
                                    onChange={(e) => setTitulo(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Nombre de la Promoción"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '100%'
                                    }}
                                />
                            </div>
                        </div>


                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}>
                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={ratioOtrosBancos}
                                    onChange={(e) => setRatioOtrosBancos(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Ratio Otros Bancos(Ej: 1.2)"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />
                            </div>

                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={ratioItau}
                                    onChange={(e) => setRatioItau(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Ratio para Itaú (Ej: 1.3)"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />
                            </div>

                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={ratioItauPersonalBank}
                                    onChange={(e) => setRatioItauPersonalBank(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Ratio para Itaú Personal Bank(Ej: 1.4)"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '100%'
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}>
                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={porcentajeAbsorve}
                                    onChange={(e) => setPorcentajeAbsorve(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Porcentaje del total que absorve cada local (Ej: 15.00)"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />
                            </div>

                            <div style={{ flex: 1 }} >
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox defaultChecked />}
                                        label="¿Mostrar al Locatario? (mostrar o no los datos de esta promoción en la vista del locatario)"
                                        checked={mostrarAlLocatario}
                                        onChange={(e) => setMostrarAlLocatario(e.target.checked)}
                                    />
                                </FormGroup>
                            </div>

                            <div style={{ flex: 1 }} />

                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}>
                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={montoMinimo}
                                    onChange={(e) => setMontoMinimo(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Monto mínimo para comprar un vale"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />
                            </div>

                            <div style={{ flex: 1 }}>
                                <CssTextField
                                    value={montoMaximo}
                                    onChange={(e) => setMontoMaximo(e.target.value)}
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    label="Monto máximo para comprar uno o más vales"
                                    autoCapitalize='none'
                                    autoCorrect={false}
                                    style={{
                                        marginTop: Padding.P1,
                                        width: '95%'
                                    }}
                                />
                            </div>

                            <div style={{ flex: 1 }} />

                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                            marginTop: Padding.P3
                        }}>
                            <div style={{ flex: 1 }}>
                                <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        label="Vigencia para Comprar Vales Desde"
                                        value={fechaInicio}
                                        //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                        format="DD/MM/YYYY HH:mm:ss"
                                        //formato de 24 horas
                                        ampm={false}
                                        onChange={(newValue) => {
                                            handleFechaInicio(newValue);
                                        }}
                                        sx={{
                                            width: '95%'
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ flex: 1 }}>
                                <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        label="Hasta"
                                        value={fechaHasta}
                                        //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                        format="DD/MM/YYYY HH:mm:ss"
                                        //formato de 24 horas
                                        ampm={false}
                                        onChange={(newValue) => {
                                            handleFechaHasta(newValue);
                                        }}
                                        sx={{
                                            width: '95%'
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ flex: 1 }} />

                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '100%',
                            marginTop: Padding.P3
                        }}>
                            <div style={{ flex: 1 }}>
                                <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        label="Vigencia para Canjear Vales en Locales Desde"
                                        value={fechaInicioCanjear}
                                        //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                        format="DD/MM/YYYY HH:mm:ss"
                                        //formato de 24 horas
                                        ampm={false}
                                        onChange={(newValue) => {
                                            handleFechaInicioCanjear(newValue);
                                        }}
                                        sx={{
                                            width: '95%'
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ flex: 1 }}>
                                <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        label="Hasta"
                                        value={fechaHastaCanjear}
                                        //agregar el formato de 24 horas y la fecha en formato DD/MM/YYYY
                                        format="DD/MM/YYYY HH:mm:ss"
                                        //formato de 24 horas
                                        ampm={false}
                                        onChange={(newValue) => {
                                            handleFechaHastaCanjear(newValue);
                                        }}
                                        sx={{
                                            width: '95%'
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>

                            <div style={{ flex: 1 }} />

                        </div>




                        <div style={{}}>
                            <Typography variant={'h6'} style={{ marginTop: Padding.P2 }}>
                                Prueba
                            </Typography>

                            <FormGroup>
                                <FormControlLabel
                                    control={<Checkbox defaultChecked />}
                                    label="¿Es Prueba? (La promoción se mostrará solamente a usuarios habilitados para pruebas)"
                                    checked={activoStatus}
                                    onChange={(e) => setActivoStatus(e.target.checked)}
                                />
                            </FormGroup>
                        </div>


                        <Stack direction="row" spacing={5} style={{ marginTop: Padding.P3 }}>
                            <Button variant="contained" onClick={handleGuardar}>
                                Guardar
                            </Button>

                            <Button variant="outlined" onClick={handleCancelar}>
                                Cancelar
                            </Button>
                        </Stack>





                    </div>
                </Box>
            </Box>
        </Box>
    )
}

export default PromocionAddComponents;